import React, { useEffect, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import * as Yup from 'yup';
import FormikDirectImageUpload from '../../components/formik/FormikDirectImageUpload';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { toast } from 'react-toastify';
import { X } from 'react-feather';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import EditQuotationTemplateModal from './EditQuotationTemplateModal';
import DocumentPreview from '../Products/DocumentPreview';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import ShowDropdown from '../../components/infrastructure/ShowDropdown';



const Quotation_templates = () => {
    const [templates, setTemplates] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [previewImg, setPreviewImg] = useState(null);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const fetchTemplates = async () => {
        try {
            const res = await authAxiosInstance.get('/quotationTemplate');
            setTemplates(res.data.data.docs);
        } catch (error) {
            toast.error('Failed to fetch templates');
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const handleDelete = async (id) => {
        try {
            console.log("@@", id)
            await authAxiosInstance.delete(`/quotationTemplate/${id}`);
            toast.success('Template deleted');
            fetchTemplates();
        } catch (error) {
            toast.error('Failed to delete template');
        }
    };
    console.log("templates", templates)
    const cols = [
        {
            Header: 'SR NO',
            Cell: (prop) => {
                const { row } = prop;
                return row.index + 1;
            },
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Firm',
            accessor: 'firm',
        },
        {
            Header: 'Header Image',
            Cell: ({ row }) => {
                return (
                    <div className="w-[100px] cursor-pointer">
                        {row?.original?.headerImg ? (
                            <img
                                src={`${process.env.REACT_APP_S3_URL}${row.original.headerImg}`}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setPreviewModalOpen(true);
                                    setPreviewImg([row?.original?.headerImg]);
                                }}
                            />
                        ) : (
                            <p>no image</p>
                        )}
                    </div>
                );
            },
        },
        {
            Header: 'Footer Image',
            Cell: ({ row }) => {
                return (
                    <div className="w-[100px] cursor-pointer">
                        {row?.original?.footerImg ? (
                            <img
                                src={`${process.env.REACT_APP_S3_URL}${row.original.footerImg}`}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setPreviewModalOpen(true);
                                    setPreviewImg([row?.original?.footerImg]);
                                }}
                            // style={{ maxWidth: '100px' }}
                            />
                        ) : (
                            <p>no image</p>
                        )}
                    </div>
                );
            },
        },
        {
            Header: 'Terms Image',
            Cell: ({ row }) => {
                return (
                    <div className="w-[100px] ">
                        {row?.original?.termsImg?.length > 0 ? (
                            <div className='cursor-pointer' onClick={(e) => {
                                e.stopPropagation()
                                setPreviewModalOpen(true);
                                setPreviewImg(row?.original?.termsImg);
                            }}>
                                <img
                                    src={`${process.env.REACT_APP_S3_URL}${row.original.termsImg[0]}`}

                                //style={{ maxWidth: '100px' }}
                                /> <p className='underline text-indigo-500 hover:text-indigo-600 '>View More</p>
                            </div>
                        ) : (
                            <p>No Image</p>
                        )}
                    </div>
                );
            },
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <div className="flex gap-2">
                        <MdDelete
                            size={20}
                            onClick={() => {
                                if (window.confirm('Are you sure you want to delete this template?')) {
                                    handleDelete(row.original._id || row.original.id); // ✅ fallback
                                }
                            }}
                            className="cursor-pointer text-red-500"
                        />

                        <MdEdit
                            size={20}
                            className="cursor-pointer text-blue-500"
                            onClick={(e) => {
                                e.stopPropagation();
                                setEditData(row.original);
                                setShowEditModal(true);
                            }}
                        />
                    </div>

                );
            },
        },
    ];

    const formik = useFormik({
        initialValues: {
            name: "",
            firm: "",
            headerImg: "",
            footerImg: "",
            termsImg: [],
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
            firm: Yup.string().required("Firm name is required"),
            headerImg: Yup.string().required("Header image is required"),
            footerImg: Yup.string().required("Footer image is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const updatedValues = {
                    ...values,
                    termsImg: values?.termsImg?.filter(
                        (item) => item !== ""
                    ),
                };
                console.log("updatedValues", updatedValues);
                await authAxiosInstance.post('/quotationTemplate', updatedValues);
                toast.success('Template created successfully');
                resetForm()
                fetchTemplates();

            } catch (error) {
                toast.error('Failed to create template');
                console.log(error);
            }
        }
    });

    return (
        <PageWithCard heading="Quotation Templates">
            <DocumentPreview
                previewModalOpen={previewModalOpen}
                setPreviewModalOpen={setPreviewModalOpen}
                previewImg={previewImg}
            />
            <EditQuotationTemplateModal
                showEditModal={showEditModal}
                setShowEditModal={setShowEditModal}
                editData={editData}
                onSuccess={fetchTemplates}
            />
            <ShowDropdown
                heading={'Add Quotation Templates'}
                allowedRoles={['admin', 'sup_admin', 'local_admin']}
            >
                <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4 sm:p-6 md:p-8 max-w-full">

                    <div className="flex flex-col gap-4 sm:gap-5">
                        <FormikInputGroup
                            name={'name'}
                            label="Name"
                            formik={formik}
                            required
                        />
                        <FormikInputGroup
                            name={'firm'}
                            label="Firm Name"
                            formik={formik}
                            required
                        />
                    </div>

                    <div className="flex flex-col gap-4 sm:gap-5 mt-2">
                        <div className='flex items-center gap-2'>
                            <FormikDirectImageUpload
                                label="Header Image"
                                name={'headerImg'}
                                location={'iml_group/quotation_templates/'}
                                randomize
                                formik={formik}
                            />
                            <span className="text-sm text-gray-600">
                                Size (2540px × 436px)
                            </span>
                        </div>
                        <div className='flex items-center gap-2'>
                            <FormikDirectImageUpload
                                label="Footer Image"
                                name={'footerImg'}
                                location={'iml_group/quotation_templates/'}
                                randomize
                                formik={formik}
                            />
                            <span className="text-sm text-gray-600">
                                Size (2540px × 238px)
                            </span>
                        </div>
                        <FormikProvider value={formik}>
                            <FieldArray
                                name="termsImg"
                                render={(arrayHelpers) => {
                                    return (
                                        <div className="flex flex-col gap-3">
                                            {formik.values.termsImg?.map((ele, i) => (
                                                <div
                                                    key={i}
                                                    className="flex items-center gap-2"
                                                >
                                                    <FormikDirectImageUpload
                                                        label={`Terms Image ${i + 1}`}
                                                        formik={formik}
                                                        name={`termsImg.${i}`}
                                                        randomize
                                                        location={'iml_group/quotation_templates/'}
                                                    />

                                                    <DangerButton
                                                        type="button"
                                                        onClick={() => {
                                                            arrayHelpers.remove(i);
                                                        }}
                                                    >
                                                        Remove
                                                    </DangerButton>
                                                </div>
                                            ))}

                                            <div className="flex items-center gap-2">
                                                <PrimaryButton
                                                    className={"px-2 py-1"}
                                                    type="button"
                                                    onClick={() => {
                                                        arrayHelpers.push('');
                                                    }}
                                                >
                                                    Add Terms Image
                                                </PrimaryButton>
                                                <span className="text-sm text-gray-600">
                                                    Size (2400px × 3400px)
                                                </span>
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                        </FormikProvider>
                    </div>

                    <div className="mt-2 mb-4">
                        <PrimaryButton
                            className={"w-full sm:w-auto"}
                            type="submit"
                            disabled={formik.isSubmitting}
                        >
                            Submit
                        </PrimaryButton>
                    </div>
                </form>
            </ShowDropdown>
            {/* Templates Table */}
            <div className="mt-6">
                <TableWithHeadingAndSearch
                    columns={cols}
                    data={templates?.length ? templates : []}
                    heading="Quotation Templates List"
                />
            </div>
        </PageWithCard>
    );
};

export default Quotation_templates;